import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { ITopPlayer, ITournament } from '../../../../page/tournaments/tournaments.interface';
import { TournamentsService } from '../../../../page/tournaments/tournaments.service';
import { ModalService } from '../../../modal/modal.service';
import { map, tap } from 'rxjs/operators';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { TextGradientComponent } from '../text-gradient/text-gradient.component';
import { NgClass, AsyncPipe, DecimalPipe } from '@angular/common';
import {
  TournamentLeadersModalComponent,
} from '../../../modal/components/lazy/tournament-leaders-modal/tournament-leaders-modal.component';

@Component({
  selector: 'app-tournament-leaders',
  templateUrl: './tournament-leaders.component.html',
  styleUrls: ['./tournament-leaders.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TextGradientComponent, NgClass, AsyncPipe, DecimalPipe, TranslatePipe],
})
export class TournamentLeadersComponent implements OnInit, OnChanges {

  /**
   * Top players for leader board
   */
  public topPlayers$: Observable<ITopPlayer[]>;

  private _tournamentItem: ITournament;

  @Input('tournament') tournament: ITournament | any = null;
  @Input() countLeaders = 5;
  @Input() hideBtn: boolean;
  @Input() hideTitle: boolean;

  constructor(
    private _tournaments: TournamentsService,
    private _modal: ModalService,
  ) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.tournament) {
      this._tournamentItem = this.tournament;
      this.topPlayers$ = combineLatest([this._tournamentItem.prizesData$, this._tournamentItem.tournamentUserStatus$]).pipe(
        map(([data, status]) => this._tournaments.mapTopPlayers(data, status)?.slice(0, this.countLeaders)),
      );

      this.topPlayers$.subscribe(console.log)
    }
  }

  async showLeaders() {
    const component = await import('../../../../core/modal/components/lazy/tournament-leaders-modal/tournament-leaders-modal.component');
    await this._modal.openLazy(component?.TournamentLeadersModalComponent, {
      data: this._tournamentItem,
      template: 'CLEAR',
    });
  }
}
